// src/mixins/toastMixin.js

export default {
  data() {
  },
  methods: {
    makeToast(title, contents, append = false, variant = 'info') {
      this.$bvToast.toast(`${contents}`, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000,
        variant: variant,
        toastClass: 'custom-toast',
      });
    },
  },
  created() {
    this.$EventBus.$on('make-toast', this.makeToast);
  },
};
